import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    RemoveInvitedMutation,
    RemoveInvitedMutationVariables,
    ResendInviteMutation,
    ResendInviteMutationVariables,
} from './InvitedItem.mutations.generated'

export const RESEND_INVITE: TypedDocumentNode<
    ResendInviteMutation,
    ResendInviteMutationVariables
> = gql`
    mutation ResendInvite($input: inviteToEventInput!) {
        inviteToEvent(input: $input) {
            event {
                ... on Event {
                    guid
                }
            }
            status {
                item
                status
            }
        }
    }
`

export const DELETE_INVITED: TypedDocumentNode<
    RemoveInvitedMutation,
    RemoveInvitedMutationVariables
> = gql`
    mutation RemoveInvited($input: deleteEventAttendeesInput!) {
        deleteEventAttendees(input: $input) {
            entity {
                guid
            }
        }
    }
`
